var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"estrategia",attrs:{"open":_vm.open}},[_c('h4',{on:{"click":function($event){_vm.open = !_vm.open}}},[_vm._v(_vm._s(_vm.estrategia.nombre))]),(_vm.open)?_c('div',{staticClass:"contenedor-tabla-estrategia"},[_c('resultados',{attrs:{"type":'actuaciones',"data":_vm.actuaciones(_vm.estrategia.id),"cansearch":true}})],1):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }